import PatternRounded from '@mui/icons-material/PatternRounded';
import { Avatar, Backdrop, Button, styled, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import React, { useRef } from 'react';
import { StyledTypography } from '../../styles';
import styles from './styles'; 
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, rePopulate } from '../../actions/auth';
import jwt_decode from "jwt-decode";
import {BiGhost} from 'react-icons/bi'; 
import SearchBar from '../Searchbar/SearchBar';
import theme from '../../muiTheme';
import { Box } from '@mui/system';
import { FiX, FiBell, FiSearch, FiSend } from "react-icons/fi";
import placeHolderImage from "../../images/post_placeholder.jpeg";
import { showNotificationsAction } from '../../actions/dynamicUI';
import { showChatAction } from '../../actions/chatUI';

const NavBar = ({ updateAuth }) => {

    const [user, setUser] = useState(null); 
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const authStateSlice = useSelector((state) => state.authReducer);
    const {notifications, total, totalUnread} = useSelector((state) => state.notificationsReducer);
    const {showNotifications, showProfileMenu} = useSelector((state) => state.dynamicUIReducer);
    const {showChat} = useSelector((state) => state.chatUIReducer);
    const isMobile = useMediaQuery('(max-width: 768px)');
    const [showSearch, setShowSearch] = useState(false);
    const navbarHomeRef = useRef(null);
    const anchor = useRef(null);
    const [navbarTopCSS, setNavbarTopCSS] = useState('calc(-100vh + 85px)'); 
    const { pathname } = useLocation();

    useEffect(()=>{
        //process profile on load
        processProfile(true);

        //set navbar top
        setNavbarTopCSS(computeTop());

    }, []);

    useEffect(()=>{
        console.log('auth state has changed: ', authStateSlice );
        //Process profile when the state slice mutates/changes (I know the state is immutable - but you know what I mean)
        processProfile();

        console.log('*******NotificationStateSlice: ', notifications);

    },[authStateSlice, pathname]);

    const processProfile = (reload=false) => {

        var profile = JSON.parse(localStorage.getItem('profile')); //obtained from loaclstorage in the case of a refresh, as redux state will be clear
        
        //sync store with obtained data
        if(reload){
            dispatch(rePopulate(profile));
        }
        
        console.log('profile: ', profile);

        if(profile){
            setUser(profile);

            //check for token
            const token = profile?.token; 
            const decodedToken = token ? jwt_decode(token) : null;

            //check if JWT expired here
            if(decodedToken && decodedToken.exp * 1000 < new Date().getTime()){

                signOut();
            }


        }else {
            setUser(null);

        }

        updateAuth(profile);
    }

    const signOut = () => {

        console.log('signout invoked');

        dispatch(logout());

        navigate('/');

    }

    const handleOverlayClick = (event) => {

        let className = event.target.getAttribute('class') || ''; 
        if(className.includes('popup-overlay')){
            setShowSearch(false); 
        }
    }

    const computeTop = () => {

        let navBarHomeHeight = '100vh'; 

        //get height of ref
        if(navbarHomeRef?.current){
            
            navBarHomeHeight = navbarHomeRef.current.offsetHeight || navBarHomeHeight; 
        }

        console.log('navbar-home-ref height: ', navBarHomeHeight);

        return `calc(-${navBarHomeHeight}px + ${isMobile ? '65' : '80' }px)`; 
    }

    const toggleNotifications = () => {


        dispatch(showNotificationsAction({showNotifications: !showNotifications }));
    }

    const toggleChat = () => {


        dispatch(showChatAction(!showChat));
    }

    const IconLink = styled(Link)(({theme}) => ({
        
        fontSize: 60,
        [theme.breakpoints.down('sm')]: {
            fontSize: 40,
        }
    
    }));

    const TitleLink = styled(Link)(({theme}) => ({
        
        // [theme.breakpoints.down('sm')]: {
        //     // position: 'absolute',
        //     // top: '12px',
        //     //left: '45%'
        // }
    
    }));

    return (

        <div ref={navbarHomeRef} className='navbar-container' style={{...styles.navbarContainer, height: isMobile ? 'auto' : 'auto', top: navbarTopCSS}}>

            {/* {
                pathname == '/posts' &&

                <LandingPage anchor={anchor} /> 
            } */}

            <Typography variant='body2'
                sx={{
                    position: 'fixed',
                    background: '#4ca56b',
                    color: 'white',
                    top: '0px',
                    left: '0px',
                    width: '120px',
                    height: '20px',
                    zIndex: '1000',
                    transform: 'rotate(-45deg) translate(-35px, -10px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >   
                W I P
            </Typography>
            

            <div ref={anchor} className='custom-appbar' style={{...styles.customAppBar, height: isMobile ? '65px' : '80px', top: '0px'}}>

                <Box
                    display={{xs: 'flex'}}
                    position={{xs: 'absolute'}}
                    left={{xs: '30px', md: '50px', lg: '5vw'}}
                    sx={{justifyContent: 'center', alignItems: 'center', flexDirection: 'row'}}
                >

                    <IconLink to='/' style={styles.link}>

                        <BiGhost style={styles.logo}/>
                    </IconLink>

                    <TitleLink to='/' style={styles.titleLink}>

                        <Typography to='/' variant='logo' sx={styles.typography}>
                            QuickShot
                        </Typography>
                    </TitleLink>
                </Box>
                
                

                {
                    !isMobile &&
                    <SearchBar style={styles.searchBar}/>
                }

                <Box
                    display={{xs: 'flex'}}
                    position={{xs: 'absolute', md: 'absolute'}}
                    right={{xs: '30px', md: '50px', lg: '5vw'}}
                    sx={{justifyContent: 'center', alignItems: 'center', flexDirection: 'row'}}
                >
                    { isMobile ? 

                        

                            <>
                            
                            
                                <FiSearch style={{color: theme.palette.grayDark, fontSize: '25px', marginTop: '5px'}} onClick={()=>setShowSearch(prevValue=>!prevValue)}/>

                                {
                                    user && 

                                    <Box
                                        sx={{
                                            position: 'relative',
                                            marginLeft: '20px',
                                        }}

                                        onClick={toggleNotifications}
                                    >

                                        {
                                            totalUnread > 0 &&

                                            <Box
                                                sx={{
                                                    position: 'absolute',
                                                    width: '21px',
                                                    height: '21px',
                                                    right: '-5px',
                                                    top: '3px',
                                                    border: '2px solid white',
                                                    borderRadius: '20px',
                                                    color: 'white',
                                                    background: 'rgba(240,40,73,1.0)',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}
                                            >
                                                <Typography 
                                                    variant='body2'
                                                    sx={{
                                                        fontSize: '10px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {totalUnread}
                                                </Typography>
                                            </Box>
                                        }
                                        

                                        <FiBell 
                                        className='notification-icon'
                                        style={{
                                            color: theme.palette.grayDark, 
                                            fontSize: '25px', 
                                            marginTop: '9px', 
                                            padding: '5px 5px'
                                            
                                            }} />
                                    </Box>
                                }
                                

                            </>
                        :

                        <>
                            

                            <Toolbar variant='nav-bar' sx={{maxWidth: '200px'}}>
                                {user ? 
                                    <div className='appbar-profile-container' style={styles.profileContainer}>

                                        <Box
                                            sx={{
                                                position: 'relative',
                                                marginX: '30px',
                                            }}

                                            onClick={toggleNotifications}
                                        >

                                            {
                                                totalUnread > 0 &&

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        width: '21px',
                                                        height: '21px',
                                                        right: '-5px',
                                                        top: '3px',
                                                        border: '2px solid white',
                                                        borderRadius: '20px',
                                                        color: 'white',
                                                        background: 'rgba(240,40,73,1.0)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <Typography 
                                                        variant='body2'
                                                        sx={{
                                                            fontSize: '10px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                       {totalUnread}
                                                    </Typography>
                                                </Box>
                                            }
                                            

                                            <FiBell 
                                            className='notification-icon'
                                            style={{
                                                color: theme.palette.grayDark, 
                                                fontSize: '25px', 
                                                marginTop: '9px', 
                                                padding: '5px 5px'
                                                
                                                }} />
                                        </Box>

                                        <Box
                                            sx={{
                                                position: 'relative',
                                                marginRight: '30px',
                                            }}

                                            onClick={toggleChat}
                                        >

                                            {
                                                totalUnread > 0 &&

                                                <Box
                                                    sx={{
                                                        position: 'absolute',
                                                        width: '21px',
                                                        height: '21px',
                                                        right: '-5px',
                                                        top: '3px',
                                                        border: '2px solid white',
                                                        borderRadius: '20px',
                                                        color: 'white',
                                                        background: 'rgba(240,40,73,1.0)',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <Typography 
                                                        variant='body2'
                                                        sx={{
                                                            fontSize: '10px',
                                                            fontWeight: '500'
                                                        }}
                                                    >
                                                       {totalUnread}
                                                    </Typography>
                                                </Box>
                                            }
                                            

                                            <FiSend 
                                            className='notification-icon'
                                            style={{
                                                color: theme.palette.grayDark, 
                                                fontSize: '25px', 
                                                marginTop: '9px', 
                                                padding: '5px 5px'
                                                
                                                }} />
                                        </Box>
                            

                                        <Link to={`/profile/${user.result._id}`}>

                                            <Avatar alt={user?.result?.name} src={user?.result?.profileImage || placeHolderImage}>
                                                {user?.result?.name.charAt(0)}
                                            </Avatar>
                                        </Link>
                                        

                                        

                                            
                                        {/* <Typography variant='h6' color='secondary' sx={{margin: 2}}>
                                            {user?.result?.name}
                                        </Typography> */}

                                        {/* <Button onClick={signOut} variant='main' color='secondary' sx={styles.button}>
                                            Sign Out
                                        </Button> */}
                                            
                                        
                                        

                                        

                                    </div>

                                    :

                                    <Button component={Link} to='/auth' variant='main' color='secondary' sx={styles.button}>
                                        Sign In
                                    </Button>
                                }
                            </Toolbar>


                        </>
                    }

                    </Box>

                

                <Backdrop
                    open={showSearch}
                    sx={styles.popUpOverlay}
                >

                    
                        
                        <Box
                            className='popup-overlay'
                            
                            sx={styles.popUpBox}
                            onClick={handleOverlayClick} 
                        >
                            { showSearch && 

                                <>
                                    <SearchBar style={{marginTop: '7px', maxWidth: '80%', marginLeft: '15px'}}  />

                                    <button className='searchButton' style={{...styles.searchButton}} onClick={()=>setShowSearch(prevValue=>!prevValue)}>
                                        <FiX style={{color: 'white'}}/>
                                    </button>
                                </>
                            }
                            
                        </Box>
                            
                                
                        
                        
                    
                    

                </Backdrop>

            </div>
        
        </div>
    );
}

export default NavBar; 